import {
    DISPLAY_OVERLAY,
    // HIDE_OVERLAY,
    SCREEN_WIDTH,
    HEADER_NAVIGATION,
    SET_MOBILE_MENU_STATE,
    MOBILE_OVERLAY_SHOW_HIDE,
    WINDOW_SCROLL,
    SET_NOTIFICATION,
    SET_MYACCOUNTINFO,
    SET_AUTH_STATUS,
    GET_RULES,
    GET_RULES_COMPONENT,
    GET_RULES_FAILURE,
    SET_ACCESS_TOKEN,
    SET_PAGE_CONTENT_DATA,
    SET_URL_RESOLVER_TOKEN,
    SET_FOOTER_DATA,
    SET_GLOBAL_DATA_LAYER,
    SET_WEEKS_DEPOSIT_BALANCE,
    SET_CUSTOMER_PROFILE,
    MSG_SIGNOUT_DATA,
    MAIN_MENU_LINK_TEXT,
    FETCH_FEEDBACK_CONTENT_SUCCESS,
    GET_GALLERY_IMAGE_SUCCESS,
    GET_GALLERY_VIDEO_SUCCESS,
    GET_GALLERY_RCI_TV_VIDEO_SUCCESS,
    FETCH_MESSAGE_CATALOG,
    FETCH_MESSAGE_CATALOG_SUCCESS,
    FETCH_MESSAGE_CATALOG_ERROR,
    SYNC_MESSAGE_CATALOG_SUCCESS,
    SET_POINTS_BALANCE,

} from "../constant";
const initialState = {
    headerNavigation: [],
    notification: [],
    myAccountInfo: [],
    showOverlay: false,
    showMobileOverlay: false,
    screenWidth: 1024,
    menuState: "ALL",
    scrollOffSet: false,
    authStatus: false,
    AEMRules: null,
    authenticating: true,
    urlResolverToken: "",
    customerId: "",
    locale: "en_US",
    accessToken: "",
    pageContent: [],
    footerData: null,
    isGlobalDataLayerSet: false,
    pointsBalance: null,
    customerProfile: null,
    msgSignoutData: null,
    mainMenuLinkText: null,
    customerCity: "",
    customerState: "",
    customerAddress: "",
    feedbackContent: {},
    messageCatalog: '',
    resortImage: [],
    resortVideo: {},
    resortRciTvVideo: {},
    dashboardDetailsByPath: null,
}

export default function commonHeaderFunc(state = initialState, action) {
    //debugger;
    switch (action.type) {
        case HEADER_NAVIGATION:
            return {
                ...state,
                headerNavigation: action.payload
            }
        case SET_NOTIFICATION:
            return {
                ...state,
                notification: action.payload
            }
        case SET_MOBILE_MENU_STATE:
            return {
                ...state,
                menuState: action.payload
            }
        case MOBILE_OVERLAY_SHOW_HIDE:
            return {
                ...state,
                showMobileOverlay: action.payload
            }

        case DISPLAY_OVERLAY:
            return {
                ...state,
                showOverlay: action.payload
            }
        case SCREEN_WIDTH:
            return {
                ...state,
                screenWidth: action.payload
            }
        case WINDOW_SCROLL:
            return {
                ...state,
                scrollOffSet: action.payload
            }
        case SET_MYACCOUNTINFO:
            return {
                ...state,
                myAccountInfo: action.payload
            }
        case SET_AUTH_STATUS:
            return {
                ...state,
                authStatus: action.payload.valid === "true" ? true : false,
                authenticating: false,
                customerId: action.payload.memberId,
                locale: action.payload.locale !== "" ? action.payload.locale : "en_US",
                customerCity: action.payload.city,
                customerState: action.payload.state,
                customerAddress: action.payload.address
            }
        case SET_ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.payload,
            }
        case SET_URL_RESOLVER_TOKEN:
            return {
                ...state,
                urlResolverToken: action.payload,
            }

        case SET_PAGE_CONTENT_DATA:
            return {
                ...state,
                pageContent: action.payload,
            }
        case SET_FOOTER_DATA:
            return {
                ...state,
                footerData: action.payload,
            }
        case SET_GLOBAL_DATA_LAYER:
            return {
                ...state,
                isGlobalDataLayerSet: action.payload,
            }
        case SET_WEEKS_DEPOSIT_BALANCE:
            return {
                ...state,
                pointsBalance: action.payload
            }
        case SET_CUSTOMER_PROFILE:
            return {
                ...state,
                customerProfile: action.payload
            }
        case MSG_SIGNOUT_DATA:
            return {
                ...state,
                msgSignoutData: action.payload
            }
        case MAIN_MENU_LINK_TEXT:
            return {
                ...state,
                mainMenuLinkText: action.payload
            }
        case FETCH_FEEDBACK_CONTENT_SUCCESS:
            return {
                ...state,
                feedbackContent: action.payload,
            };
        case GET_RULES:
            return {
                ...state,
                AEMRules: { ...action.payload },
            };
        case GET_RULES_FAILURE:
            return {
                ...state,
                AEMRules: {},
            };
        case GET_RULES_COMPONENT:
            return {
                ...state,
                [action.ruleID]: action.payload,
            };
        case GET_GALLERY_IMAGE_SUCCESS:
            return {
                ...state,
                resortImage: action.payload,
            };
        case GET_GALLERY_VIDEO_SUCCESS:
            return {
                ...state,
                resortVideo: action.payload,
            };
        case GET_GALLERY_RCI_TV_VIDEO_SUCCESS:
            return {
                ...state,
                resortRciTvVideo: action.payload,
            };
        case FETCH_MESSAGE_CATALOG:
            return {
                ...state,
            };
        case FETCH_MESSAGE_CATALOG_SUCCESS: {
            const { id, messageGroupMap } = action.payload;
            const brandCode = state.customerProfile && state.customerProfile.brandCode;
            const locale = state.customerProfile && state.customerProfile.locale;
            const catalogData =
                messageGroupMap &&
                messageGroupMap.data &&
                brandCode &&
                locale &&
                messageGroupMap.data[brandCode] &&
                messageGroupMap.data[brandCode][locale]
                    ? messageGroupMap.data[brandCode][locale][id]
                    : undefined;
            return {
                ...state,
                messageCatalog: {
                    ...state.messageCatalog,
                    [id]: catalogData
                        ? { ...catalogData, isMcServiceCallCompleted: true }
                        : { isMcServiceCallCompleted: true },
                },
            };
        }
        case SYNC_MESSAGE_CATALOG_SUCCESS:
            return {
                ...state,
                messageCatalog: action.payload,
            };
        case FETCH_MESSAGE_CATALOG_ERROR:
            return {
                ...state,
                messageCatalog: {
                    ...state.messageCatalog,
                    [action.payload.id]: {
                        isMcServiceCallCompleted: true,
                    },
                },
            };
        case SET_POINTS_BALANCE:
            return {
                ...state,
                customerInfo: action.payload,
            }
        case 'UPDATE_DASHBOARD_DETAILS':
            return {
                ...state,
                dashboardDetailsByPath: { ...action.payload },
            }
        default:
            return state;
    }
}




